export default __webpack_public_path__ + "static/media/new-logo-login.e26e0c5b.png";